/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{velocityPerSecond as t}from"../../../utils/velocity-per-second.js";function o(o,r,e){const n=Math.max(r-5,0);return t(e-o(n),r-n)}export{o as calcGeneratorVelocity};
//# sourceMappingURL=velocity.js.map
